export default ($resource, TokenService) => {
    const baseUrl = `${SEED_CORE.ENV.WP_URL}`;
    const tokenData = TokenService.decode(TokenService.token).context;
    return $resource(baseUrl, null, {
        getCompanyCourses: {
            isArray: true,
            method: 'GET',
            url: `${baseUrl}wp-json/coursy/v1/course/company-courses?slug=${tokenData.companySlug}`
        },
        getCourse: {
            method: 'GET',
            url: `${baseUrl}wp-json/coursy/v1/course/:id`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Learndash/index.js